module.exports = __webpack_public_path__ + "static/img/faqs.751d2e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/static-css/img/faqs/faqs.jpg
// module id = z3F5
// module chunks = 19